import { render, staticRenderFns } from "./PixelCatRunner.vue?vue&type=template&id=0c18be7d&scoped=true"
import script from "./PixelCatRunner.vue?vue&type=script&lang=js"
export * from "./PixelCatRunner.vue?vue&type=script&lang=js"
import style0 from "./PixelCatRunner.vue?vue&type=style&index=0&id=0c18be7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18be7d",
  null
  
)

export default component.exports